<template>
  <div class="float-right">
    <img
      src="../../assets/images2.0/forum/flag-solid.svg"
      height="16"
      title="This comment has been reported. Please make changes to the comment"
      alt="reported icon"
    />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
